export enum Roles {
  ADMIN = '1',
  PUBLIC = '2',
  WEB = '3',
  MOBILE = '4',
}
